import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { EngagementType } from 'interfaces/data/engagement-grid-container-page';
import { CommonScheduledFollowUpsGridPart } from '../../../../../ui/widget';
import { VolunteeringEngagementsService } from '../../volunteering-engagements.service';

@Component({
	selector: 'volunteering-scheduled-follow-ups-view-part',
	standalone: true,
	imports: [CommonScheduledFollowUpsGridPart],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './scheduled-follow-ups.part.html',
})
export class ScheduledFollowUpsViewPart implements OnInit {
	public readonly pageService = inject(VolunteeringEngagementsService);
	public followUps = computed(() => (this.pageService.followUps() || []));

	ngOnInit() {
		this.pageService.engagementType.set(EngagementType.scheduledFollowUps);
	}
}